import { NoddiButton } from 'noddi-ui-web';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';
import type { MemberCarsFlow } from './useMemberCarsFlow';

/** One footer for all three steps, so nothing jumps between the body and the footer. */
export const MemberCarsFooter = ({
  flow,
  onLeave,
  translations: t
}: {
  flow: MemberCarsFlow;
  onLeave: () => void;
  translations: NotificationGroupOverviewTranslations;
}) => {
  if (flow.stage === 'review') {
    return (
      <div className='flex w-full gap-2'>
        <NoddiButton variant='outline' className='flex-1' disabled={flow.isSaving} onClick={flow.goToChoose}>
          {t.back}
        </NoddiButton>
        <NoddiButton className='flex-1' loading={flow.isSaving} onClick={flow.confirm}>
          {t.confirmDriverChange}
        </NoddiButton>
      </div>
    );
  }

  return (
    <div className='flex w-full gap-2'>
      <NoddiButton variant='outline' className='flex-1' onClick={onLeave}>
        {t.back}
      </NoddiButton>
      <NoddiButton className='flex-1' disabled={flow.changes.length === 0} onClick={flow.goToReview}>
        {t.continueToReview}
      </NoddiButton>
    </div>
  );
};
